<div mat-dialog-title>
  <div>
    Recent Hits
    <span *ngIf="data.cameraName">: {{ data.cameraName }}</span>
  </div>
  <button mat-icon-button color="warn" matTooltip="Close" mat-dialog-close>
    <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
  </button>
</div>
<sn-data-list [fetchFn]="loadData" #list>
  <sn-infinite-scroll class="infiniteScrollList">
    <ng-template [ngIf]="list.dataSource.data.length">
      <ng-container
        id="fs-plate-cards"
        (scroll)="onScroll($event)"
        *ngIf="list.dataSource.data.length > 0 || !list.dataIsInited"
      >
        <ng-container>
          <sn-plate-card
            id="{{ plate.id }}"
            *ngFor="let plate of list.dataSource.data; let i = index; trackBy: trackPlate"
            [plate]="plate"
            [ngClass]="{ active: seletItem === plate.id, active: i === activeIndex }"
          ></sn-plate-card>
        </ng-container>
      </ng-container>
    </ng-template>
    <ng-template [ngIf]="!list.dataSource.data.length && list.dataIsInited">
      <sn-empty-state icon="cancel_presentation" title="No Results">
        No results match search criteria
      </sn-empty-state>
    </ng-template>
  </sn-infinite-scroll>
</sn-data-list>
